import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sidebar-page-content" }
const _hoisted_2 = { class: "events-sidebar__previews" }
const _hoisted_3 = { class: "frame" }
const _hoisted_4 = { class: "frame__overview" }
const _hoisted_5 = { class: "frame__header label-m" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_7 = { class: "frame" }
const _hoisted_8 = { class: "frame__overview" }
const _hoisted_9 = { class: "frame__header label-m" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_11 = { class: "frame" }
const _hoisted_12 = { class: "frame__overview" }
const _hoisted_13 = { class: "frame__header label-m" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "frame attributes"
}
const _hoisted_16 = { class: "frame__overview" }
const _hoisted_17 = { class: "frame__header label-m" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_19 = { class: "attributes__content" }
const _hoisted_20 = { class: "frame acknowledgment" }
const _hoisted_21 = { class: "frame__overview" }
const _hoisted_22 = { class: "frame__header label-m" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_24 = { class: "acknowledgment__content label-mono-m" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NThumbnail = _resolveComponent("NThumbnail")!
  const _component_MatchedCardInfo = _resolveComponent("MatchedCardInfo")!
  const _component_NForm = _resolveComponent("NForm")!
  const _component_WatchListsGroup = _resolveComponent("WatchListsGroup")!
  const _component_CameraLabels = _resolveComponent("CameraLabels")!
  const _component_EventItemAttributeLineCross = _resolveComponent("EventItemAttributeLineCross")!
  const _component_Attributes = _resolveComponent("Attributes")!
  const _component_Acknowledge = _resolveComponent("Acknowledge")!
  const _component_AcknowledgeInfo = _resolveComponent("AcknowledgeInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NThumbnail, {
        class: "events-sidebar__previews-event",
        "model-value": _ctx.eventView.thumbnail,
        size: "extra-large",
        onClick: _ctx.showFullscreen
      }, null, 8, ["model-value", "onClick"]),
      (_ctx.eventView.matched_card)
        ? (_openBlock(), _createBlock(_component_MatchedCardInfo, {
            key: 0,
            id: _ctx.eventView.matched_card,
            type: _ctx.cardType,
            "object-id": _ctx.eventView.matched_object,
            "object-type": _ctx.objectType,
            confidence: _ctx.eventView.confidence
          }, null, 8, ["id", "type", "object-id", "object-type", "confidence"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('common.other', 'f')), 1),
        _hoisted_6
      ]),
      _createVNode(_component_NForm, {
        layout: _ctx.infoFields,
        model: _ctx.item
      }, null, 8, ["layout", "model"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('common.watch_lists', 'f')), 1),
        _hoisted_10
      ]),
      (_ctx.item?.matched_lists)
        ? (_openBlock(), _createBlock(_component_WatchListsGroup, {
            key: 0,
            items: _ctx.item.matched_lists,
            marker: _ctx.marker,
            "tag-view": "",
            "text-size": "normal"
          }, null, 8, ["items", "marker"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('common.cameras', 'f')), 1),
        _hoisted_14
      ]),
      _createVNode(_component_CameraLabels, {
        "camera-groups-ids": _ctx.eventView.camera_groups,
        "cameras-ids": _ctx.eventView.cameras,
        "video-archive-id": _ctx.eventView.video_archive,
        "has-play": _ctx.hasPlay,
        onAction: _cache[0] || (_cache[0] = (v, id) => _ctx.handleCameraAction(v, id))
      }, null, 8, ["camera-groups-ids", "cameras-ids", "video-archive-id", "has-play"])
    ]),
    (_ctx.hasAttributes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('common.attributes', 'f')), 1),
            _hoisted_18
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_Attributes, { items: _ctx.attributesItems }, {
              [_ctx.extraAttributesSlot]: _withCtx(() => [
                (_ctx.hasLineCross)
                  ? (_openBlock(), _createBlock(_component_EventItemAttributeLineCross, {
                      key: 0,
                      item: _ctx.item,
                      classes: "label-2xs"
                    }, null, 8, ["item"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["items"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('common.acknowledgement', 'f')), 1),
        _hoisted_23
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_Acknowledge, {
          item: _ctx.item,
          style: {"width":"160px"},
          onAction: _cache[1] || (_cache[1] = (v, p) => v && _ctx.$emit('action', v, p)),
          disabled: !_ctx.modelAcl.update
        }, null, 8, ["item", "disabled"]),
        (_ctx.item.acknowledged)
          ? (_openBlock(), _createBlock(_component_AcknowledgeInfo, {
              key: 0,
              item: _ctx.item,
              onAction: _cache[2] || (_cache[2] = (v, p) => v && _ctx.$emit('action', v, p))
            }, null, 8, ["item"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}